import { render, staticRenderFns } from "./nxMobileGroup.vue?vue&type=template&id=33f33582&scoped=true&"
import script from "./nxMobileGroup.vue?vue&type=script&lang=js&"
export * from "./nxMobileGroup.vue?vue&type=script&lang=js&"
import style0 from "./nxMobileGroup.vue?vue&type=style&index=0&id=33f33582&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f33582",
  null
  
)

export default component.exports